
module.exports = {

    methods: {

        debouncer: _.debounce(callback => callback(), 1000),

    }

}
